import { Injectable } from '@angular/core';
import { TextAnimationStep } from '../../../../animation/text-animation.service';
import { TextCell } from '../../studio.types';
import { TextPosition } from './text-topology-process.service';

@Injectable({ providedIn: 'root' })
export class TextAnimationGeneratorService {
  constructor() {}

  generateAnimation(cell: TextCell): TextAnimationStep {
    const { text, topology, position } = cell;

    // -- // -- //

    // switch (position) {
    //   case TextPosition.LEFT_TOP:
    //   case TextPosition.LEFT_BOTTOM:
    //     translateFrom = [-50, 0]; // from left
    //     break;
    //   case TextPosition.RIGHT_TOP:
    //   case TextPosition.RIGHT_BOTTOM:
    //     translateFrom = [50, 0]; // from right
    //     break;
    //   case TextPosition.CENTER:
    //   default:
    //     translateFrom = [0, 50]; // from bottom
    //     break;
    // }

    console.log('text-animation-generator', position);
    switch (position) {
      case TextPosition.LEFT_TOP:
      case TextPosition.LEFT_BOTTOM:
      case TextPosition.RIGHT_TOP:
      case TextPosition.RIGHT_BOTTOM:
        // -- // -- // -- // -- //
        return {
          type: 'appear',
          duration: 1,
          forceFade: true,
          line: {
            delay: 0.3,
            translate: {
              mask: true,
              from: [0, 150],
            },
          },
        } as TextAnimationStep;
      case TextPosition.CENTER:
      default:
        return {
          type: 'appear',
          duration: 1,
          forceFade: true,
          zoom: {
            from: 0.5,
            to: 1,
          },
        } as TextAnimationStep;
    }

    return null;
  }

  private generateDefaultAnimation(text: string): TextAnimationStep {
    return {
      type: 'appear',
      duration: 1,
      forceFade: true,
      zoom: {
        from: 0.8,
        to: 1,
      },
    };
  }
}
